const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1600;
const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 900;

export const IS_PORTRAIT_LAYOUT = viewportHeight > viewportWidth;
export const GAME_WIDTH = IS_PORTRAIT_LAYOUT ? 900 : 1600;
export const GAME_HEIGHT = IS_PORTRAIT_LAYOUT ? 1600 : 900;
export const UI_CENTER_X = GAME_WIDTH / 2;
export const UI_CENTER_Y = GAME_HEIGHT / 2;
export const PLAYER_SPEED = 240;
export const PLAYER_SIZE = { width: 42, height: 60 };

export const DEPTH = {
  GROUND: 10,
  OBJECT_BASE: 100,
  ACTOR: 1000,
  OCCLUDER_FRONT: 5000,
  UI: 10000,
};

export const DEV = {
  RELOAD_KEY: 'R',
  TOGGLE_DEBUG_KEY: 'T',
  TOGGLE_DEV_OVERLAY: 'F1',
};
